<div class="confirm-header">
    {{modalText$ | async | translate}}
</div>
<div *ngFor="let item of updatableItems$ | async">
    <p class="basic-black-normal-text mb-0">
        {{'common.new' | translate | appFirstLetterUppercase}} {{getTranslateKey(item.name) | translate | appFirstLetterUppercase}}
    </p>
    <p class="basic-blue-normal-text white-space-text">{{item.selected}}</p>
</div>
